import { FieldGroup } from "@/components/ui/field";
import { FormChipList, FormDatePicker, SectionCard } from "components/BaseForm";

const OrdersSection = () => (
  <SectionCard title="Orders">
    <FieldGroup className="tw:grid tw:grid-cols-1 tw:gap-5 tw:md:grid-cols-2">
      <div className="tw:md:col-span-2">
        <FormChipList
          name="purchase_order"
          label="Purchase Order Number (P.O.#)"
          placeholder="Type a P.O. number and press Enter"
        />
      </div>
      <FormChipList
        name="invoice"
        label="Invoice #"
        placeholder="Type an invoice number and press Enter"
      />
      <FormDatePicker name="invoice_date" label="Invoice Date" />
      <FormChipList
        name="sales_order"
        label="Sales Order Number (S.O.#)"
        placeholder="Type an S.O. number and press Enter"
      />
      <FormDatePicker name="sales_order_date" label="S.O. Date" />
    </FieldGroup>
  </SectionCard>
);

export default OrdersSection;
